import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { useFormContext } from 'react-hook-form';
import { useAccessManagement2NModal } from '../../../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import styles from './styles.module.scss';

export const FormActions = ({ isLoading, onSubmit }) => {

  const { updateSelected, updateAdding } = useAccessManagement2NModal();
  const formContext = useFormContext();
  const { formState } = formContext;

  return (
    <div className={styles.actionContainer}>
      <Button
        basic
        name="cancel-add-access-rule"
        type="button"
        disabled={isLoading}
        onClick={() => {
          updateSelected('accessRule', null);
          updateAdding('accessRule', false);
        }}
      >
        <FormattedMessage id="cancel" />
      </Button>
      <Button
        primary
        name="submit-add-access-rule"
        disabled={!formState.isDirty || isLoading}
        loading={isLoading}
        onClick={formContext.handleSubmit(onSubmit)}
      >
        <FormattedMessage id="addNewAccessRule" />
      </Button>
    </div>
  );
};
